import { Box, Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';

export const FeedSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container maxWidth="sm">
      <Box p={2}>
        <Skeleton variant="rectangular" width={64} height={30} style={{ borderRadius: 5 }} />
      </Box>

      <Grid container justifyContent={"center"} spacing={2}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Grid key={`IF_SKE_${i}`} item style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Skeleton variant="rectangular" style={{ borderRadius: 5 }} width={isMobile ? 350 : 552} height={150} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default FeedSkeleton;
